<template>
    <div class="produkt-stapel my-3 w-100 px-5 px-md-0">
        <transition :name="transition" appear mode="out-in" >
            <produkt
                :key="aktuellerIndex"
                :produkt="aktuellesProdukt"
                :i18n="optionen.i18n"
                :herkunftIntern="optionen.herkunftIntern"
                :paramKommeVon="optionen.paramKommeVon"
                :isLazyLoad="optionen.imgLazyLoad"
                :srcBildPlatzhalter="srcBildPlatzhalter"
                @produkt-next="naechstesProdukt"
                @produkt-prev="vorherigesProdukt"
            />
        </transition>
    </div>
</template>

<script>
    import Helpers from '../Helpers';
    import Produkt from './Produkt.vue';

    export default {
        name: 'produkt-stapel',
        components: {
            Produkt,
        },
        data() {
            return {
                aktuellesProdukt: {
                    ID_PRODUKT: '',
                    NAME: '',
                    KURZTEXT: '',
                    BILD_URL: '',
                    URL: ''
                },
                aktuellerIndex: 0,
                letzterIndex: 0,
                transition: '',
                transitions: {
                    mobile: {
                        next: 'slide-fade-left',
                        prev: 'slide-fade-right',
                    },
                    desktop: {
                        next: 'slide-fade-down',
                        prev: 'slide-fade-up',
                    }
                },
                istMobile: false,
            }
        },
        props: {
            produktDaten: {
                type: Array,
                default: () => []
            },
            srcBildPlatzhalter: {
                type: String,
                default: '',
            },
            optionen: {
                type: Object,
                default: () => {},
            }
        },
        methods: {
            naechstesProdukt() {
                if (!this.produktDaten || this.aktuellerIndex == this.produktDaten.length - 1) {
                    return;
                }

                this.letzterIndex = this.aktuellerIndex;
                this.aktuellerIndex++;
                this.$emit('aktualisiere-index', this.aktuellerIndex);
                this.aktuellesProdukt = this.produktDaten[this.aktuellerIndex];
                this.aendernTransition('next');

                if (this.aktuellerIndex == this.produktDaten.length - this.optionen.request.limitNaechsteAnforderung) {
                    this.$emit('aktualisiere-daten');
                }

            },
            vorherigesProdukt() {
                if (!this.produktDaten || this.aktuellerIndex == 0) {
                    return;
                }

                this.letzterIndex = this.aktuellerIndex;
                this.aktuellerIndex--;
                this.$emit('aktualisiere-index', this.aktuellerIndex);
                this.aktuellesProdukt = this.produktDaten[this.aktuellerIndex];
                this.aendernTransition('prev');
            },
            aendernTransition(richtung='next') {
                if (!this.istMobile) {
                    this.transition = this.transitions.desktop[richtung];
                } else {
                    this.transition = this.transitions.mobile[richtung];
                }
            },

        },
        created() {
            const self = this;
            this.istMobile = Helpers.pruefenDarstellungIstMobil(this.optionen.responsive.breakpointDesktop);
            self.aendernTransition();

            window.addEventListener('resize', () => {
                this.istMobile = Helpers.pruefenDarstellungIstMobil(this.optionen.responsive.breakpointDesktop);
            });

            // aktuelles Produkt setzen
            if (this.produktDaten && this.produktDaten.length > 0) {
                this.aktuellesProdukt = this.produktDaten[0];
            }
        }
    }


</script>

<style>

    .slide-fade-down-enter {
        transform: translateY(-120%);
        opacity: 1;
    }

    .slide-fade-down-enter-active {
        transition: all 800ms cubic-bezier(0, 1.35, 0.4, 1);
    }

    .slide-fade-down-enter-to {
        opacity: 1;
        transform: translateY(0);
    }

    .slide-fade-down-leave {
        opacity: 1;
        transform: translateY(0);
    }

    .slide-fade-down-leave-active {
        transition: all 800ms cubic-bezier(0, -0.35, 0.4, 1);
    }

    .slide-fade-down-leave-to {
        opacity: 1;
        transform: translateY(120%);
    }

    .slide-fade-up-enter {
        transform: translateY(120%);
        opacity: 1;
    }

    .slide-fade-up-enter-active {
        transition: all 800ms cubic-bezier(0, 1.35, 0.4, 1);
    }

    .slide-fade-up-enter-to {
        transform: translateY(0);
        opacity: 1;
    }

    .slide-fade-up-leave {
        opacity: 1;
        transform: translateY(0);
    }

    .slide-fade-up-leave-active {
        transition: all 800ms cubic-bezier(0, -0.35, 0.4, 1);
    }

    .slide-fade-up-leave-to  {
        transform: translateY(-120%);
        opacity: 1;
    }

    .slide-fade-left-enter-active,
    .slide-fade-left-leave-active,
    .slide-fade-right-enter-active,
    .slide-fade-right-leave-active {
        opacity: 1;
        transform: translateX(0) scale3d(1.006, 1.006, 1);
        transition: all 400ms ease-in-out;
    }

    .slide-fade-left-enter,
    .slide-fade-right-leave-to  {
        transform: translateX(120%) rotate(10deg) scale3d(1.006, 1.006, 1);
        opacity: 0.8;
    }

    .slide-fade-left-leave-to,
    .slide-fade-right-enter  {
        transform: translateX(-120%) rotate(-10deg) scale3d(1.006, 1.006, 1);
        opacity: 0.8;
    }

</style>
